/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DefinitionActionSubKindEnum {
    FormEditDraft = 10,
    FormEditApplication = 20,
    FormAgentInfo = 30,
    FormCounterpartyInfo = 40,
    FormExchangeRates = 50,
    FormWalletsWhichTransfer = 60,
    FormProvideWallets = 70,
    FormTransferFiat = 80,
    FormTransactionId = 90,
    SignExchangeContract = 100,
    SignExchangeAct = 110,
    SignTransferContract = 120,
    SignTransferAct = 130,
    UploadClientPaymentDoc = 200,
    UploadAdminToProviderDoc = 201,
    UploadTransferCommessionRecepotDoc = 202,
    UploadTransferRecepotDoc = 203,
    FormTransferProvideWallets = 700,
}
